import { NgModule } from '@angular/core';
import { NgFlowDesignerComponent } from './ng-flow-designer.component';
import { NgFlowDesignerOutputDirective } from './ng-flow-designer-output.directive';
import { NgFlowDesignerNodeDirective } from './ng-flow-designer-node.directive';
import { NgFlowDesignerEdgeControllerDirective } from './ng-flow-designer-edge-controller.directive';

@NgModule({
  declarations: [
    NgFlowDesignerComponent,
    NgFlowDesignerOutputDirective,
    NgFlowDesignerNodeDirective,
    NgFlowDesignerEdgeControllerDirective,
  ],
  imports: [],
  providers: [NgFlowDesignerEdgeControllerDirective],
  exports: [
    NgFlowDesignerComponent,
    NgFlowDesignerOutputDirective,
    NgFlowDesignerNodeDirective,
    NgFlowDesignerEdgeControllerDirective,
  ],
})
export class NgFlowDesignerModule {}
